import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { H6, Image, LI, P, UL } from '../../../AbstractElements'
import { dynamicImage } from '../../../Utils'

import SvgIcon from '../../../Utils/CommonComponents/CommonSvgIcons'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';
import { useAuth } from '../../../Context/AuthContext';
import { mediaUrl } from '../../../Utils';

export default function UserWrap() {
    const [open, setOpen] = useState(false)
    const dropdownRef = useRef<HTMLLIElement>(null);
    const { user, clearAuthData } = useAuth();
    const navigate = useNavigate();
    const toggle = () => {
        setOpen(!open)
    }
    const confirmLogout = () => {
        Swal.fire({
            title: 'Log out?',
            text: 'Are you sure you want to log out?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, log out',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                logout();
            }
        });
    };

    const logout = () => {
        clearAuthData();
        toast.info("Logged out successfully!");
        navigate("/login", { replace: true });
    };

    // Click outside dropdown handler
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <li className="profile-nav custom-dropdown" ref={dropdownRef}>
            <div className="user-wrap" onClick={toggle}>
                <div className="user-img">
                    <Image
                        src={user?.profile_image ? `${mediaUrl}${user.profile_image}` : dynamicImage(`profile.png`)}
                        alt="user"
                        style={{
                            objectFit: 'cover',
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%'
                        }}
                    />
                </div>
                <div className="user-content">
                    <H6>{user?.name || 'User'}</H6>
                    <P className="mb-0">{user?.role || 'Guest'}<i className="fa-solid fa-chevron-down" /></P>
                </div>
            </div>
            <div className={`custom-menu overflow-hidden ${open ? 'show' : ''}`}>
                <UL className="profile-body simple-list">
                    <LI className="d-flex" onClick={confirmLogout}>
                        <SvgIcon className='svg-color' iconId='Login' />
                        <span className="ms-2 text-primary" style={{ cursor: "pointer" }}>
                            Log Out
                        </span>
                    </LI>
                </UL>
            </div>
        </li>
    )
}